export default __webpack_public_path__ + "static/media/icon-kelas-ac.1738d867.png";